import * as R from 'ramda'

class UserData {
    constructor({
        clientId,
        userUuid,
        email,
        firstName,
        lastName,
        isAdmin,
        isMultiAccount,
        isClientReseller,
        isReseller,
        locale,
        role,
        timezone,
        clientName,
        userId,
        flags,
        benchmarks,
        jobTitle,
        sessionId,
        loginId,
        dashboardStatus,
    }) {
        this.clientId = clientId
        this.userUuid = userUuid
        this.email = R.or(email, '')
        this.firstName = R.or(firstName, '')
        this.lastName = R.or(lastName, '')
        this.clientName = R.or(clientName, '')
        this.username = `${this.firstName} ${this.lastName}`
        this.isAdmin = R.or(isAdmin, false)
        this.isReseller = R.or(isReseller, false)
        this.isMultiAccount = R.or(isMultiAccount, false)
        this.isClientReseller = R.or(isClientReseller, false)
        this.locale = R.or(locale, 'en_GB')
        this.role = role
        this.timezone = R.or(timezone, 'Europe/London')
        this.userId = userId
        this.jobTitle = jobTitle
        this.sessionId = sessionId
        this.loginId = loginId
        this.benchmarks = ['industry', 'company', 'division', 'portfolio']
            .reduce((map, b) => {
                map[b] = benchmarks.includes(b)
                return map
            }, {
                sector: benchmarks.includes('industry'),
            })
        this.dashboardStatus = R.or(dashboardStatus, 'none')
        this.flags = {
            isClientDashboardsEnabled: R.or(flags.isClientDashboardsEnabled, false),
            isUserDashboardsEnabled: R.or(flags.isUserDashboardsEnabled, false),
            ceClient: R.or(flags.ceClient, false),
            isNewDashboardEnabled: R.or(flags.isNewDashboardEnabled, false),
            isDistributedDisabled: R.or(flags.isDistributedDisabled, false),
            pptLevel: R.or(flags.pptLevel, 0),
            isDeliveryReportEnabled: R.or(flags.isDeliveryReportEnabled, false),
            isExhibitMeasurementEnabled: R.or(flags.isExhibitMeasurementEnabled, false),
            isRapidSurveysEnabled: R.or(flags.isRapidSurveysEnabled, false),
            isProSurveysEnabled: R.or(flags.isProSurveysEnabled, false),
            isMultiDivision: R.or(flags.isMultiDivision, false),
            isClientOnsite: R.or(flags.isClientOnsite, false),
            isClientIntercept: R.or(flags.isClientIntercept, false),
            isClientEmbed: R.or(flags.isClientEmbed, false),
            isClientQR: R.or(flags.isClientQR, false),
            isClientCustomerJourneyEnabled: R.or(flags.isClientCustomerJourneyEnabled, false),
            isSpssEnabled: R.or(flags.isSpssEnabled, false),
            isMGEEnabled: R.or(flags.isMGEEnabled, false),
            anonymizeReport: R.or(flags.anonymizeReport, false),
            isV4DashboardEnabled: R.or(flags.isV4DashboardEnabled, false),
            useReportCache: R.or(flags.useReportCache, false),
            isRegistrationFilterEnabled: R.or(flags.isRegistrationFilterEnabled, false),
            isRapidEmailsEnabled: R.or(flags.isRapidEmailsEnabled, false),
            isCertificationEnabled: R.or(flags.isCertificationEnabled, false),
            isAiSummaryEnabled: R.or(flags.isAiSummaryEnabled, false),
        }
    }
}

export default UserData
